module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlay),
      expression: "overlay"
    }],
    staticClass: "deleting-overlay"
  }, [_vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Hjælp til MålerTjek")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('p', [_vm._v("\n                                Hvis du oplever problemer med at den ikke vil synkronisere dit data, kan en\n                                mulig løsning være, at fjerne dine lokale ændringer. Dette vil resultere i,\n                                at alle ændringer siden sidst du synkroniserede, vil gå tabt. Hvis du ønsker\n                                at slette dine lokale data, klik på knappen nedenfor.\n                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                Har du brug for support til MålerTjek, kan du ringe på support-telefonen \n                                "), _c('b', [_vm._v("2857 5859")]), _vm._v(" eller sende en e-mail til "), _c('a', {
      attrs: {
        "href": "mailto:infosupport@niras.dk?Subject=MålerTjek",
        "target": "_top"
      }
    }, [_vm._v("infosupport@niras.dk")]), _vm._v(".                                \n                            ")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "grid-x"
    }, [_c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-right": "4px"
      }
    }, [_c('a', {
      staticClass: "button",
      on: {
        "click": _vm.closeModal
      }
    }, [_vm._v("Luk")])]), _vm._v(" "), _c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-left": "4px"
      }
    }, [_c('a', {
      staticClass: "button call-to-action",
      on: {
        "click": _vm.clearAll
      }
    }, [_vm._v("Slet data")])])])]
  })], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter text-center"
  }, [_c('h3', [_vm._v("Sletter lokale data"), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4474995e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpmodal.vue
// module id = 1009
// module chunks = 1